import Vue from 'vue'
import drawer from './drawer'

const FilterDrawer = Vue.extend(drawer)

function filterDrawer(options = {}) {
  const vm = this;
  const key = `__${options.id || 'drawer'}__`
  if(!vm.$el[key]) {
    const instance = vm.$el[key] = new FilterDrawer({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
    instance.initData(options)
  }
  vm.$el[key].show()
  return vm.$el[key]
}

Vue.prototype.$filterDrawer = filterDrawer